import { render, staticRenderFns } from "./CompaniesSelect.vue?vue&type=template&id=28ae3fa6"
import script from "./CompaniesSelect.vue?vue&type=script&lang=js"
export * from "./CompaniesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports